import { AfterContentInit, AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild,  } from '@angular/core';
import { ProductosDTO } from 'src/app/model/productosDTO';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Categoria } from 'src/app/model/categoria';
import { CategoriaService } from 'src/app/services/api/categoria.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProductoDTOService } from 'src/app/services/api/productoDTO.service';
import { TokenStorageServiceCliente } from 'src/app/services/api/TokenStorageServiceCliente';
import { db } from 'src/app/services/bd/bd';
import { App as CapacitorApp } from '@capacitor/app';
import { HostListener } from '@angular/core';
import { style } from '@angular/animations';
import { ViewportScroller } from '@angular/common';

declare let $: any;

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css'],

})
export class InicioComponent  implements OnInit {
  @ViewChild("videoPlayer", { static: false }) videoplayer?: ElementRef;
  @HostListener('window:scroll', [])

  onWindowScroll() {
   
   if (
     document.body.scrollTop > 100 ||
     document.documentElement.scrollTop > 100
   ) {
     document.getElementById('appear')?.classList.add('active')
    
     
   }
   else(
     document.getElementById('appear')?.classList.remove('active')

   )
 }
 
 title = 'WhatsApp';


  CantidadItem:string="0";
productosdto:ProductosDTO[]=[];
countpedido:string="0";
urlServerUpload$ : string = `${environment.HOST}/api/categoria/`;
urlServerUploadArticulos$ : string = `${environment.HOST}/api/media/`;
tipoMedia$ : String = "/1";
tipoMedia2$ : String = "/0";
contarPedido:number=0;
nombreCuenta:String="Mi cuenta";
categoriadto:Categoria[]=[];
formBuscar!: FormGroup;
modoBusqueda:boolean=false;
 $rs:string="";
 tieneSession:boolean=false ;
 idUsrDTO:number=0;
 ocultarCarrito:boolean=false;
 time: number = 0;

  
  constructor(
  //  private productoDTOService : ProductoDTOService,
    private router:Router,
    private tokenStorage: TokenStorageServiceCliente,
    private categoriaService : CategoriaService,
    private productoDTOService:ProductoDTOService,
    private scroller: ViewportScroller,

    
  ) { 
    CapacitorApp.addListener('backButton', ({canGoBack}) => {
      if(!canGoBack){
        CapacitorApp.exitApp();
      } else {
        window.history.back();
      }
    });
  }


  
  ngOnInit() {

    

    this.formBuscar = new FormGroup({
      'txtBuscar' : new FormControl('', Validators.required),
    });


    this.OnContarPedido();
    



this.OnGetCategoria();

if (this.tokenStorage.getToken()!==null) {
  let json = JSON.stringify(this.tokenStorage.getUser());
  let data=JSON.parse(json.toString());
  this.idUsrDTO=data.idUsuario;
  this.nombreCuenta=data.nombre
  this.tieneSession=true ;
    }

   
const evideo =this.videoplayer?.nativeElement;

this.scroller.scrollToAnchor("targetInicio");


  }




  OnGetCategoria(){

    this.categoriaService.getCategoria().subscribe(response =>{
    //  console.log(response)
    //  return this.categoriadto=response
    for(let dato of response) {
    const listatemp: Categoria= {
      idCategoria:dato.idCategoria,
      descripcion:dato.descripcion,
      imagen:this.urlServerUpload$+dato.imagen+this.tipoMedia$

    }
    this.categoriadto.push(listatemp);


  }


  //console.log(this.categoriadto)

    })

   
  }

  OnContarPedido(){
    this.ContarRegistros().then(data => {
     //localStorage.setItem('countPedido', data+"");
     this.CantidadItem=data+"";

    });
  }


  async ContarRegistros() {
    return await db.detallePedidoBD.count();
    }

  onBuscarPorModelo(){

  
    this.modoBusqueda=true ;
this.productosdto=[];

this.productoDTOService.getProductosDTOByEstadoAndModelo(0,this.formBuscar.value['txtBuscar']).subscribe(response =>{
  console.log(response)



    this.$rs="1";
     return this.productosdto=response;
  
})

console.log(this.$rs)

  }
  


  OnHabilitarBusqueda(){
    this.ocultarCarrito=true;
  }
  
  OnCerrarBusqueda(){
    this.ocultarCarrito=false;
  }
  

playVideo(){
 
  
}


OnBuscarAll(){

this.modoBusqueda=true ;
this.productosdto=[];

this.productoDTOService.getProductosDTOByDescripcion(0,this.formBuscar.value['txtBuscar']).subscribe(response =>{
  console.log(response);

    return  this.productosdto=response;
  
});
}

OnSelectProducto(_idproducto:any){

  this.router.navigate(['/pedido', _idproducto,0,0,0,0,0]);
}

  OnSelectArticuloPorCategoria(id:any){

   // this.router.navigate(['/articulos', id])

   this.router.navigate(['/articulos',id])
   .then(() => {
     window.location.reload();
   });


  }


  logout(){
    this.tokenStorage.signOut();
    localStorage.removeItem('shopping');

    this.router.navigate(['/inicio'])
    .then(() => {
      window.location.reload();
    });

  }



}
